module.exports = __webpack_public_path__ + "img/8.d81f9d57.jpg";